import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Paper, Typography, Box, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import { useQuery } from 'shared/hooks';
import { exportToExcel } from 'services';

import { getShopProductValues } from '../shared/functions/getShopProductValues/getShopProductValues';
import { setShopActiveViewAction } from '../store/shopActions';
import { getPurchasedProducts } from '../selectors/shopSelectors';
import { ShopSelectionList } from './ShopSelectionList/ShopSelectionList';

const useStyle = makeStyles(() => ({
  title: {
    position: 'relative',
    top: 2,
  },
}));

const ShopPurchases = () => {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();
  const { tab } = useQuery();
  const navigate = useNavigate();

  const products = useSelector(getPurchasedProducts);

  const [selectedProducts, setSelectedProducts] = useState([]);

  const handleSelectionChange = (items) => {
    setSelectedProducts(items);
  };

  const backToProductList = () => {
    navigate({
      search: ``,
    });
  };

  const actions = [
    {
      name: t('Export to Excel'),
      action: () => {
        if (!selectedProducts.length) return;

        const filteredProducts = products.data
          .filter(({ id }) => selectedProducts.includes(id))
          .map((product) =>
            getShopProductValues(product, [
              'name',
              'purchaseDate',
              'validity',
              'subscriptionUntil',
              'category',
              'price',
            ]),
          );

        exportToExcel({
          fileName: `ShopPurchases`,
          workbookName: t('My purchases'),
          columns: [
            t('Name'),
            t('Date of purchase'),
            t('Validity'),
            t('Renewal / end'),
            t('Category'),
            t('Price'),
          ],
          data: filteredProducts,
        });
      },
    },
  ];

  useEffect(() => {
    dispatch(setShopActiveViewAction({ view: tab || null }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);

  return (
    <>
      <Box mb={1}>
        <Typography variant="h5">
          <IconButton onClick={backToProductList} size="large">
            <ArrowBackIcon />
          </IconButton>
          <span className={classes.title}>{t('My purchases')}</span>
        </Typography>
      </Box>
      <Paper elevation={3}>
        <ShopSelectionList
          actions={actions}
          products={products.data}
          onSelectionChange={handleSelectionChange}
          columns={[
            'name',
            'purchaseDate',
            'validity',
            'subscriptionUntil',
            'category',
            'pricing',
            'actions',
          ]}
          showFreeTrialPrice
        />
      </Paper>
    </>
  );
};

export { ShopPurchases };
